import { api } from './axios';
import { PresentationEntity } from '../interfaces/presentations';
import { ISO8601ToTime } from '@/helpers/isoToTime';

export const getPresentations = async (eventId: string) => {
  const presentationQuery = `query getPresentations { 
    presentationList (where: { eventId: { eq: "${eventId}"}}) { 
      nodes { 
        id
        imageId
        name
        speakerFIO
        speakerInfo
        description
        time
      } 
    } 
  }`;

  const presentations = api
    .post('', {
      query: presentationQuery,
      operationName: 'getPresentations'
    })
    .then((res) => {
      return sortPresentationList(res.data.data.presentationList.nodes);
    })
    .catch((res) => res.data);

  return presentations;
};

const sortPresentationList = (
  presentationList: PresentationEntity[]
): PresentationEntity[] => {
  return [...presentationList].sort((a, b) => {
    return (
      Date.parse('1970/01/01 ' + ISO8601ToTime(a.time)) -
      Date.parse('1970/01/01 ' + ISO8601ToTime(b.time))
    );
  });
};
